"use client"

import { Crosshair } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CrosshairIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CrosshairIcon = component(Icon)({ as: Crosshair })
